import "./App.css";
import Die from "./Die.js";
import { useState, useEffect, useRef } from "react";

function App() {
  const [dice, setDice] = useState(() => allNewDice());
  const [tenzies, setTenzies] = useState(false);
  const [rollCount, setRollCount] = useState(0);
  const [time, setTime] = useState(0); // Timer state
  const timeHandler = useRef(null); // useRef to store the interval ID
  const [bestTime, setBestTime] = useState(() => {
    // Retrieve best time from localStorage or set to null if it doesn't exist
    const savedBestTime = localStorage.getItem("bestTime");
    return savedBestTime ? JSON.parse(savedBestTime) : null;
  });

  // Function to start the timer
  function startTimer() {
    timeHandler.current = setInterval(() => {
      setTime((prevTime) => prevTime + 1); // Increment time every second
    }, 1000);
  }

  // Start timer when the game begins and stop it when the game ends
  useEffect(() => {
    if (tenzies) {
      clearInterval(timeHandler.current); // Stop timer when game is won
    } else {
      startTimer(); // Start timer when game starts or a new game is initiated
    }

    return () => clearInterval(timeHandler.current); // Clean up on unmount or before new interval
  }, [tenzies]);

  // Effect to check if the game is won
  useEffect(() => {
    const allDiceAreEqual = dice.every((die) => die.value === dice[0].value);
    const allDiceAreHeld = dice.every((die) => die.isHeld);
    if (allDiceAreEqual && allDiceAreHeld) {
      setTenzies(true);
      checkBestTime(time); // Check if current time is a new record
    } else {
      setTenzies(false);
    }
  }, [dice]);

  // Function to check and store the best time in localStorage
  function checkBestTime(currentTime) {
    if (bestTime === null || currentTime < bestTime) {
      setBestTime(currentTime); // Update state with new best time
      localStorage.setItem("bestTime", JSON.stringify(currentTime)); // Save best time in localStorage
    }
  }

  // Function to generate new dice
  function allNewDice() {
    const dice = [];
    for (let i = 0; i < 10; i++) {
      dice.push({ value: Math.floor(Math.random() * 6) + 1, isHeld: false });
    }
    return dice;
  }

  // Function to roll the dice
  function rollDice() {
    if (!tenzies) {
      setDice((oldDice) =>
        oldDice.map((die) => {
          return die.isHeld
            ? die
            : { value: Math.floor(Math.random() * 6) + 1, isHeld: false };
        })
      );
    } else {
      setTenzies(false);
      setDice(allNewDice());
      setRollCount(-1); // Reset roll count to 0 when a new game is started
      setTime(0); // Reset timer when a new game is started
    }
    setRollCount((oldRollCount) => oldRollCount + 1);
  }

  // Function to hold dice
  function holdDice(id) {
    const newDice = dice.map((die, index) => {
      if (index === id) {
        return { ...die, isHeld: !die.isHeld };
      } else {
        return die;
      }
    });
    setDice(newDice);
  }

  const dieElements = dice.map((die, index) => {
    return (
      <Die
        key={index}
        value={die.value}
        isHeld={die.isHeld}
        id={index}
        holdDice={holdDice}
      />
    );
  });

  return (
    <main>
      <h1 className="title">Tenzies</h1>
      <p className="instructions">
        Roll until all dice are the same. Click each die to freeze it at its
        current value between rolls.
      </p>
      <h2 className="roll--count">
        Roll Count: {rollCount} | Time: {time}s
      </h2>
      {bestTime !== null && (
        <h3 className="best--time">Best Time: {bestTime}s</h3>
      )}
      <div className="die--container">{dieElements}</div>
      <button onClick={rollDice}>{tenzies ? "New Game" : "Roll Dice"}</button>
    </main>
  );
}

export default App;
